import axios from "axios";
import * as Constants from "../constant";
const getDashboardExperinces = async (data) => {
	try {
		const response = await axios.get(
			`${Constants?.LOCAL_URL}/account-space/${data}`
		);
		return response.data;
	} catch (error) {
		return error;
	}
};
export default getDashboardExperinces;
